import { Offcanvas } from 'react-bootstrap';
import ReviewBody from './reviewBody';
import { ReportedActionRequestType, ReportedDetailsRequestType } from '../../types/report';
import { PartnerReportedDetailsRequestType } from '../../types/partnerReport';

interface ReviewSidebarProps {
    show: boolean;
    suspendReasonText: string;
    handleClose: () => void;
    type: 'reviewReport' | 'replyReport';
    reportedData: ReportedDetailsRequestType | PartnerReportedDetailsRequestType | null;
    actionData: ReportedActionRequestType | null;
    getList: () => void;
    isPartner?: boolean;
}

const ReviewSidebar: React.FC<ReviewSidebarProps> = ({
    show,
    handleClose,
    type,
    reportedData,
    actionData,
    suspendReasonText,
    getList,
    isPartner = false,
}) => {
    const renderContent = () => {
        return (
            <ReviewBody
                reportedData={reportedData}
                type={type}
                actionData={actionData}
                suspendReasonText={suspendReasonText}
                handleClose={handleClose}
                getList={getList}
                isPartner={isPartner}
            />
        );
    };

    return (
        <Offcanvas show={show} onHide={handleClose} placement="end" backdropClassName="review-offcanvas">
            <Offcanvas.Header closeButton>
                <h5 className="fs-16 fw-600 mb-0 text-capitalize">Review Details</h5>
            </Offcanvas.Header>
            <Offcanvas.Body className="lt-bg-gray-10 p-0">
                <div className="p-3">{renderContent()}</div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default ReviewSidebar;
